export function setUserProfessions(professions, userId) {
  return {
    endpoint: `users/${userId}/professions`,
    method: 'POST',
    data: professions,
    requireAuth: true,
    convertApiErrorsToReduxFormErrors: true,
  };
}
